import angular from 'angular';
import booksMenu from '../../menu/Menu';

/**
 * The main code is actually in CSMBooksWeb/src/ui. It seems like they originally intended to move the code from CSMBooksWeb
 * into CSMBooks instead. There is a TODO comment within the index.aspx located in CSMBooks that mentions this.
 * This code is needed, because it is currently looking for a module name App, previously was just a script tag in the index.aspx.
 * 
 * TODO: Need to consolidate the code between CSMBooksWeb/src/ui/itemSummaryReport and CSMBooksWeb/src/csmBooks/reports/itemSummaryReport
 */
export default angular.module('App', [booksMenu]).name;